var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShip2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 179,
    viewBox: "0 0 36 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.798828 33.1506V151.228C0.798828 159.782 4.51988 164.092 4.51988 164.092H31.4552C31.4552 164.092 35.1762 159.782 35.1762 151.228V33.1506C35.1762 3.61939 17.9875 0 17.9875 0C17.9875 0 0.798828 3.61939 0.798828 33.1506Z",
    fill: "#F2320C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95742 23.4102C3.48297 26.0942 3.20508 38.7078 3.20508 42.1781H32.7702C32.7702 38.7078 32.4923 26.0942 32.0178 23.4102H3.95742Z",
    fill: "#5D3E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07129 12.1188H27.8966C23.5859 5.27994 17.9805 4.10059 17.9805 4.10059C17.9805 4.10059 12.3752 5.27994 8.07129 12.1188Z",
    fill: "#5D3E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7702 42.1787H3.20508V153.458H32.7702V42.1787Z",
    fill: "#694B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0621 62.1602H4.90625V133.484H31.0621V62.1602Z",
    fill: "#D2D0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4078 133.815H4.56738V61.8135H31.401V133.815H31.4078ZM5.25195 133.137H30.73V62.4913H5.24517V133.137H5.25195Z",
    fill: "#D55C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51953 164.086C4.51953 164.086 13.0258 177.994 17.9872 178.841C22.9486 179.689 31.4548 164.086 31.4548 164.086H4.51953Z",
    fill: "#F2320C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20508 153.458C3.20508 153.458 9.3255 171.48 17.9876 171.48C25.6399 171.48 31.5841 158.582 32.7702 153.458H3.20508Z",
    fill: "#694B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9947 46.9629H17.9879C12.3579 46.9629 7.79395 51.5269 7.79395 57.1568V66.4696C7.79395 72.0996 12.3579 76.6636 17.9879 76.6636H17.9947C23.6246 76.6636 28.1886 72.0996 28.1886 66.4696V57.1568C28.1886 51.5269 23.6246 46.9629 17.9947 46.9629Z",
    fill: "#191514",
    stroke: "#E30613",
    strokeWidth: 1.35558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1551 78.7734H9.82715V124.646H26.1551V78.7734Z",
    fill: "#F2F0D7",
    stroke: "#9D9D9C",
    strokeWidth: 0.677788,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9179 103.004H12.0498V121.223H23.9179V103.004Z",
    fill: "#FCFAEB",
    stroke: "#B2B2B2",
    strokeWidth: 0.677788,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9871 155.986C19.3834 155.986 20.5153 154.854 20.5153 153.458C20.5153 152.062 19.3834 150.93 17.9871 150.93C16.5909 150.93 15.459 152.062 15.459 153.458C15.459 154.854 16.5909 155.986 17.9871 155.986Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9871 144.905C19.3834 144.905 20.5153 143.773 20.5153 142.377C20.5153 140.981 19.3834 139.849 17.9871 139.849C16.5909 139.849 15.459 140.981 15.459 142.377C15.459 143.773 16.5909 144.905 17.9871 144.905Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9871 40.8639C19.3834 40.8639 20.5153 39.732 20.5153 38.3358C20.5153 36.9395 19.3834 35.8076 17.9871 35.8076C16.5909 35.8076 15.459 36.9395 15.459 38.3358C15.459 39.732 16.5909 40.8639 17.9871 40.8639Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9871 29.7819C19.3834 29.7819 20.5153 28.65 20.5153 27.2537C20.5153 25.8575 19.3834 24.7256 17.9871 24.7256C16.5909 24.7256 15.459 25.8575 15.459 27.2537C15.459 28.65 16.5909 29.7819 17.9871 29.7819Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6607 99.1807H12.3213V101.072H23.6607V99.1807Z",
    stroke: "#B2B2B2",
    strokeWidth: 0.677788,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6607 94.3887H12.3213V96.2797H23.6607V94.3887Z",
    stroke: "#B2B2B2",
    strokeWidth: 0.677788,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6607 90.1328H12.3213V92.0238H23.6607V90.1328Z",
    stroke: "#B2B2B2",
    strokeWidth: 0.677788,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53586 135.781H5.79395V138.16H7.53586V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11984 44.584H4.37793V46.963H6.11984V44.584Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11984 48.5967H4.37793V50.9757H6.11984V48.5967Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11984 52.7783H4.37793V55.1574H6.11984V52.7783Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9363 44.5029H30.1943V46.882H31.9363V44.5029Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9947 79.5381H17.9879C12.3579 79.5381 7.79395 84.1021 7.79395 89.732V99.0448C7.79395 104.675 12.3579 109.239 17.9879 109.239H17.9947C23.6246 109.239 28.1886 104.675 28.1886 99.0448V89.732C28.1886 84.1021 23.6246 79.5381 17.9947 79.5381Z",
    fill: "#191514",
    stroke: "#E30613",
    strokeWidth: 1.35558,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9363 48.5156H30.1943V50.8947H31.9363V48.5156Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9363 52.6973H30.1943V55.0763H31.9363V52.6973Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3689 135.781H8.62695V138.16H10.3689V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.195 135.781H11.4531V138.16H13.195V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.029 135.781H14.2871V138.16H16.029V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.862 135.781H17.1201V138.16H18.862V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6882 135.781H19.9463V138.16H21.6882V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5212 135.781H22.7793V138.16H24.5212V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3474 135.781H25.6055V138.16H27.3474V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1814 135.781H28.4395V138.16H30.1814V135.781Z",
    fill: "#191514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56744 40.836C4.94177 40.836 5.24522 40.5326 5.24522 40.1583C5.24522 39.7839 4.94177 39.4805 4.56744 39.4805C4.1931 39.4805 3.88965 39.7839 3.88965 40.1583C3.88965 40.5326 4.1931 40.836 4.56744 40.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56744 36.1671C4.94177 36.1671 5.24522 35.8636 5.24522 35.4893C5.24522 35.115 4.94177 34.8115 4.56744 34.8115C4.1931 34.8115 3.88965 35.115 3.88965 35.4893C3.88965 35.8636 4.1931 36.1671 4.56744 36.1671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05572 29.7745C5.43005 29.7745 5.73351 29.4711 5.73351 29.0967C5.73351 28.7224 5.43005 28.4189 5.05572 28.4189C4.68139 28.4189 4.37793 28.7224 4.37793 29.0967C4.37793 29.4711 4.68139 29.7745 5.05572 29.7745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4893 40.836C31.8636 40.836 32.1671 40.5326 32.1671 40.1583C32.1671 39.7839 31.8636 39.4805 31.4893 39.4805C31.115 39.4805 30.8115 39.7839 30.8115 40.1583C30.8115 40.5326 31.115 40.836 31.4893 40.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4893 36.1671C31.8636 36.1671 32.1671 35.8636 32.1671 35.4893C32.1671 35.115 31.8636 34.8115 31.4893 34.8115C31.115 34.8115 30.8115 35.115 30.8115 35.4893C30.8115 35.8636 31.115 36.1671 31.4893 36.1671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.001 29.7745C31.3754 29.7745 31.6788 29.4711 31.6788 29.0967C31.6788 28.7224 31.3754 28.4189 31.001 28.4189C30.6267 28.4189 30.3232 28.7224 30.3232 29.0967C30.3232 29.4711 30.6267 29.7745 31.001 29.7745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56744 141.61C4.94177 141.61 5.24522 141.307 5.24522 140.933C5.24522 140.558 4.94177 140.255 4.56744 140.255C4.1931 140.255 3.88965 140.558 3.88965 140.933C3.88965 141.307 4.1931 141.61 4.56744 141.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56744 146.28C4.94177 146.28 5.24522 145.977 5.24522 145.603C5.24522 145.228 4.94177 144.925 4.56744 144.925C4.1931 144.925 3.88965 145.228 3.88965 145.603C3.88965 145.977 4.1931 146.28 4.56744 146.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05572 152.672C5.43005 152.672 5.73351 152.369 5.73351 151.994C5.73351 151.62 5.43005 151.316 5.05572 151.316C4.68139 151.316 4.37793 151.62 4.37793 151.994C4.37793 152.369 4.68139 152.672 5.05572 152.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4893 141.61C31.8636 141.61 32.1671 141.307 32.1671 140.933C32.1671 140.558 31.8636 140.255 31.4893 140.255C31.115 140.255 30.8115 140.558 30.8115 140.933C30.8115 141.307 31.115 141.61 31.4893 141.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4893 146.28C31.8636 146.28 32.1671 145.977 32.1671 145.603C32.1671 145.228 31.8636 144.925 31.4893 144.925C31.115 144.925 30.8115 145.228 30.8115 145.603C30.8115 145.977 31.115 146.28 31.4893 146.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.001 152.672C31.3754 152.672 31.6788 152.369 31.6788 151.994C31.6788 151.62 31.3754 151.316 31.001 151.316C30.6267 151.316 30.3232 151.62 30.3232 151.994C30.3232 152.369 30.6267 152.672 31.001 152.672Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.3774,
    height: 178.875,
    fill: "white",
    transform: "translate(0.798828)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip2);
export default __webpack_public_path__ + "static/media/ship-2.svg";
export { ForwardRef as ReactComponent };